import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController.js";
import flights_funnel_layover_price_airport_filter_web from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
export const useAirportsFilterController = () => {
    const i18n = useI18n();
    const { airports } = useSearchFiltersController();
    const handleOnChange = (checked, value) => {
        const isDisabled = airports.options?.some((city) => city.airports.some((a) => a.iata === value && a.disabled));
        if (isDisabled)
            return;
        const currentIataCodes = airports.value.map((airport) => airport.iata);
        if (checked) {
            airports.set([...currentIataCodes, value]);
        }
        else {
            airports.set(currentIataCodes.filter((iata) => iata !== value));
        }
        flights_funnel_layover_price_airport_filter_web.goals.airports();
    };
    const handleSelectSingleOption = (value) => {
        airports.set([value]);
    };
    return {
        isFilterAvailable: !!airports.options,
        title: i18n.trans(t("flights_filters_airports_title")),
        resetLabel: i18n.trans(t("flights_filter_reset")),
        options: airports.options,
        showReset: airports.touched,
        onClickReset: () => {
            airports.reset();
        },
        value: airports.value,
        onChange: handleOnChange,
        onSelectSingleOption: (value) => {
            handleSelectSingleOption(value);
        }
    };
};
